export default {
  heroHeadingTextTransform: Styles.textTransform.headlines,
  textCartConfirmationColor: Styles.color.grey.one,
  cartConfirmationItemBorder: '',
  pickupInstructionsColor: Styles.color.grey.one,
};
